import { useCallback, useEffect, useRef } from 'react';
import { createTapCounter } from './tapGesture';

function load(tag, attrs) {
  return new Promise((resolve, reject) => {
    const el = document.createElement(tag);
    Object.assign(el, attrs);
    el.onload = resolve; el.onerror = () => reject(new Error('load failed'));
    document.head.appendChild(el);
  });
}
function notice(text) {
  try {
    const d = document.createElement('div');
    d.setAttribute('role', 'status');
    d.textContent = text;
    d.style.cssText = 'position:fixed;left:50%;bottom:90px;transform:translateX(-50%);max-width:88vw;z-index:2147483600;background:#102542;color:#F7F2E8;border:1px solid #C6A15B;border-radius:12px;padding:10px 14px;font:600 13px Outfit,system-ui,sans-serif;text-align:center';
    document.body.appendChild(d);
    setTimeout(() => d.remove(), 4500);
  } catch (e) { /* ignore */ }
}
let assets;
function ensureAssets() {
  if (!assets) assets = Promise.all([
    load('link', { rel: 'stylesheet', href: '/admin.css' }),
    load('script', { src: '/admin.js' })
  ]).catch(e => { assets = null; throw e; });
  return assets;
}

// Usage: const onLogoClick = useAdminEntry({ session, appVersion });  <img onClick={onLogoClick} />
// Does nothing unless signed in; the server decides whether the person is really an admin.
export default function useAdminEntry({ session, appVersion = '', name = '' }) {
  const counter = useRef(null);
  if (!counter.current) counter.current = createTapCounter();
  const busy = useRef(false);
  const token = session && session.access_token;
  const user = session && session.user;

  // Warm up the Control Center files (and the server function) in the background once signed in,
  // so the fifth tap opens it right away instead of downloading everything at that moment.
  useEffect(() => {
    if (!token) return undefined;
    const warm = () => {
      ensureAssets().catch(() => {});
      try { fetch('/api/admin', { method: 'POST', headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` }, body: JSON.stringify({ action: 'whoami' }) }).catch(() => {}); } catch (e) { /* ignore */ }
    };
    const t = setTimeout(warm, 1500);
    return () => clearTimeout(t);
  }, [token]);

  return useCallback(async (force) => {
    if (!token || !user || !user.email || busy.current) return;
    if (force !== true && !counter.current()) return;
    busy.current = true;
    try {
      const assetsReady = ensureAssets().catch(() => null);
      const r = await fetch('/api/admin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ action: 'whoami' })
      });
      if (!r.ok) {
        // Not an admin (401/403): stay silent. A server problem is worth a visible hint for whoever is trying.
        if (r.status >= 500 || r.status === 404) {
          let why = ''; try { const j = await r.json(); why = j && j.error ? ' ' + String(j.error).slice(0, 140) : ''; } catch (e) { /* not JSON */ }
          notice('Control Center is unavailable (' + r.status + ').' + (why || ' Check the admin function in Netlify.'));
        }
        else console.warn('[radar-admin] access refused (' + r.status + ')');
        return;
      }
      const me = await r.json();
      if (!me || !me.ok) return;
      await assetsReady; await ensureAssets();
      window.RadarAdmin.open({
        getToken: () => token, name: String(name || (user.user_metadata && user.user_metadata.name) || user.email).trim(), email: user.email,
        owner: !!me.owner, userId: user.id, version: appVersion
      });
    } catch (e) { notice('Control Center is not available. Check your connection, or that the admin function is deployed.'); } finally { busy.current = false; }
  }, [token, user, appVersion, name]);
}
